/* eslint-disable no-unused-vars */

const accessRights = {
    // admin allowed to all routes
    admin: 'admin',
    supplier: 'supplier',
    sales: 'sales',
    all: ['sales', 'supplier'],
};

/**
 * Add allowed groups for route access,
 * if you need to restrict routes.
 * Not defined routes will have open access
 */
export default {
    route_access: {
        // example route name: [array of rights]
        users: accessRights.admin,
        orders: accessRights.all,

    },
};



// WEBPACK FOOTER //
// ./src/router/accessGroup.js